import { createContext, useContext } from 'react';
import { RealityWarperStore } from './RealityWarperProvider';

export const RealityWarperContext = createContext<
    RealityWarperStore | undefined
>(undefined);

export const useRealityWarper = () => {
    const context = useContext(RealityWarperContext);
    if (!context) {
        throw new Error(
            'useRealityWarper must be used within a RealityWarperProvider',
        );
    }
    return context;
};
